import {
  BUSINESS_CATEGORIES_FETCH_REQUEST,
  BUSINESS_CATEGORIES_FETCH_SUCCESS,
  BUSINESS_CATEGORIES_FETCH_FAIL,
  BUSINESSES_FETCH_MANAGED_SUCCESS,
} from '../actions/businesses'
import {
  Map as ImmutableMap,
  List as ImmutableList,
  fromJS,
} from 'immutable'
import { BUSINESSES_IMPORT } from '../actions/importer'

const initialState = ImmutableMap({
  categoriesIsFetched: false,
  categories: [],
  flatCategories: [],
  business_accounts: ImmutableMap(), // business_id: {business_account}
  items: ImmutableMap(),
})

const normalizeBusiness = (state, business) => state.setIn(['items', `${business.id}`], fromJS(business))

const normalizeBusinesses = (state, businesses) => {
  businesses.forEach((business) => {
    state = normalizeBusiness(state, business)
  })

  return state
}

export default function businesses(state = initialState, action) {
  switch(action.type) {
    case BUSINESSES_IMPORT:
      return normalizeBusinesses(state, action.businesses)
    case BUSINESSES_FETCH_MANAGED_SUCCESS:
      const { businesses, business_accounts } = action
      if (Array.isArray(business_accounts) && business_accounts.length > 0) {
        business_accounts.forEach((ba) => {
          state = state.setIn(['business_accounts', `${ba.business_id}`], fromJS(ba))
        })
      }

      return normalizeBusinesses(state, businesses)
    case BUSINESS_CATEGORIES_FETCH_SUCCESS:
      let businessed = []
      try {
        const data = action.businessCategories

        businessed = data.reduce((acc, cur) => {
          if (!cur.top_level_category_id) {
            acc.push({
              categories: [],
              top_level_category_id: cur.id, 
              top_level_category_name: cur.name,
            });
          }
          return acc
        }, [])
        businessed = businessed.map((block) => {
          const categories = data.filter((d) => {
            return `${d.top_level_category_id}` === `${block.top_level_category_id}`
          })
          return {
            ...block,
            categories,
          }
        })
      } catch (error) {
        // console.log("error:", error)
        businessed = []
      }

      state = state.set('categoriesIsFetched', true)
      state = state.set('categories', businessed)
      state = state.set('flatCategories', action.businessCategories)
      
      return state
    default:
      return state
  }
}
